// extracted by mini-css-extract-plugin
module.exports = {"checkmarkWrap":"Extension_checkmarkWrap__11Sun","optionGroup":"Extension_optionGroup__24LwZ","optionGroupText":"Extension_optionGroupText__1kC83"};